import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=78090f98&scoped=true&"
import script from "./svgIcon.vue?vue&type=script&lang=js&"
export * from "./svgIcon.vue?vue&type=script&lang=js&"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=78090f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78090f98",
  null
  
)

export default component.exports